import styled from 'styled-components';

export const breakePoints = {
    desktop: '1599px',
    sDesktop: '1365px',
    laptop: '1279px',
    tablet: '1023px',
    mobile: '767px',
    sMobile: '374px',
};

export const Domofon = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    margin-bottom: -56px;

    @media(max-width: ${breakePoints.mobile}) {
        margin-top: -40px;
    }
`;
